import { loadProjectFromCache } from './cache.ts';
import { App } from './components/app.tsx';
import { getStoredDeckIds, testGame } from './components/play-setup-panel.tsx';

export async function onTestGame() {
    let project = await App.instance.runAction('Loading cache', () => loadProjectFromCache());
    let decks = project && getStoredDeckIds(project);

    if (!decks) {
        alert('No stored deck ids.');
        return;
    }

    App.instance.setState({
        project,
    });

    testGame(project!, decks);
}